"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import FactoringCompaniesStore from "../../stores/factoring_companies_store";
import Api from "../../api/api";
import get from "../data/get";
import TypeAhead from "../ui/type_ahead";
var store = FactoringCompaniesStore;
function clean(name) {
  return name.toLowerCase().replace(/[& -]/g, "");
}
var factoringCompanyService = {
  searchByName: function(name) {
    return _.chain(this.filterByName(name)).map(function(factoringCompany) {
      return get.factoringCompanyOffices(factoringCompany);
    }).flatten().value().slice(0, 20);
  },
  filterByName: function(name) {
    return _.select(_.sortBy(store.items, this.carrierSort), function(x) {
      return s.startsWith(clean(x.name), clean(name));
    });
  },
  carrierSort: function(carrier) {
    return carrier.name;
  }
};
function factoringCompanyOfficeDisplay(factoringCompanyOffice) {
  get.factoringCompany(factoringCompanyOffice);
  var paymentAddress = get.paymentAddress(factoringCompanyOffice);
  var lines = [];
  lines.push(paymentAddress.name);
  lines.push(paymentAddress.address_line_1);
  if (paymentAddress.address_line_2) {
    lines.push(paymentAddress.address_line_2);
  }
  lines.push(paymentAddress.city + ", " + paymentAddress.state);
  return lines.join("<br>");
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    // Searches wait for the factoring companies to load.
    __publicField(this, "loaded", Api.FactoringCompanies.index());
    __publicField(this, "search", (term) => this.loaded.then(() => factoringCompanyService.searchByName(term)));
  }
  render() {
    return /* @__PURE__ */ jsx(
      TypeAhead,
      {
        remoteSearch: this.search,
        display: factoringCompanyOfficeDisplay,
        placeHolder: "Factoring Company Office",
        selectedItem: this.props.factoringCompanyOffice,
        onSelectItem: this.props.onSelect,
        onClearSelectedItem: this.props.onClear,
        onFocus: this.props.onFocus
      }
    );
  }
}
